import OrdersStatusSelector from './OrdersStatusSelector';

export default OrdersStatusSelector;